import { Component, OnInit, HostBinding, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { Observable, of, Subscription, from, identity, Subject, ReplaySubject, zip } from 'rxjs';
import { map, shareReplay, pluck, delay, flatMap, tap, filter, withLatestFrom, distinct, distinctUntilChanged, bufferCount, take } from 'rxjs/operators';
import { ProblemData, OldProblem, QuizData, Quiz, Problem } from '../header/menu/menu.component';
import { Subject as SubjectModel } from '../header/subjects/subject/subject.model';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { SliderService } from '../slider.service';
import { MillionService } from '../million.service';
import { UserService } from '../user.service';
import { UIRouter } from '@uirouter/angular';
import { UIStateService } from '../ui-state.service';
import { ApiService } from '../api.service';

@Component({
  selector: 'mea-practice-app',
  templateUrl: './practice-app.component.html',
  styleUrls: ['./practice-app.component.css']
})
export class PracticeAppComponent implements OnInit, OnDestroy {
  title = 'student-client';
  @HostBinding('class') private class = 'playground';

  user: string;

  @Output() selected: EventEmitter<any> = new EventEmitter();
  @Output() score: EventEmitter<number> = new EventEmitter<number>();
  @Input() type: 'math' | 'text';
  @Input() activity: 'practice' | 'test' | 'finalTest' | 'million' | '1vs1';
  @Input() topic: { name: string, hierarchy: string };
  @Input() path: { name: string, hierarchy: string }[] = [];
  @Input() topics?: { name: string, hierarchy: string }[];
  scoreSubscription: Subscription;

  private querySubscription: Subscription;
  loading$: Observable<boolean>;
  error$: Observable<readonly any[]>;
  quiz$: Observable<any>;

  public problems: Problem[];
  public problems$: Observable<Problem[]>;
  subjects$: Observable<SubjectModel[]>;
  current = 0;
  length = 1;
  inReview = false;
  rightAnswers = new Subject<boolean>();
  // public score: Observable<number>;

  public config: SwiperConfigInterface = {
    allowTouchMove: false,
    shortSwipes: false,
    longSwipes: false,
    direction: 'horizontal',
    slidesPerView: 1,
    navigation: true,
    pagination: true
  };

  // TODO update menu with current problem

  @ViewChild(SwiperDirective, { static: false }) set slider(slider: SwiperDirective) {
    if (slider) {
      //debugger;
      //slider.config.allowTouchMove = false;
      //debugger;
      // Solves expression changes during initialization
      this.sliderService.register(slider, this.length);
    }
  }

  /*@HostBinding('class.playground') private get loggedInCss() {
    return this.user !== undefined;
  }*/

  @HostBinding('class.playground--ingame') private get ingameCss() {
    return (this.activity === 'million' || this.activity === '1vs1');
  }

  get hideHeader() {
    const toHide = ['/login', '/register'].indexOf(this.router.urlService.path()) > -1;
    return (toHide) ? 'none' : 'grid';
  }

  atStart$: Observable<boolean>;
  atEnd$: Observable<boolean>;
  isActive$: Observable<boolean>;
  isActive_: boolean;
  newActivity$: Observable<'_' | 'practice' | 'test' | 'finalTest' | 'million' | '1vs1'>;

  showExit: Subject<boolean> = new ReplaySubject(1);
  public readonly showExit$ = this.showExit.asObservable().pipe(distinctUntilChanged());
  showReview: Subject<boolean> = new ReplaySubject(1);
  public readonly showReview$ = this.showReview.asObservable().pipe(distinctUntilChanged());
  showNav$: Observable<boolean>;

  constructor(
    private uiStateService: UIStateService,
    private apiService: ApiService,
    public sliderService: SliderService,
    public millionService: MillionService,
    private userService: UserService,
    private router: UIRouter) {

  }

  ngOnInit() {
    // debugger;
    this.atStart$ = this.sliderService.atStart;
    this.atEnd$ = this.sliderService.atEnd;
    this.isActive$ = this.sliderService.isActive;
    this.isActive$.subscribe(isActive => this.isActive_ = isActive);
    this.user = this.userService.email;

    this.uiStateService.setActivity(this.activity);

    const graphqlActivity = this.uiStateService.activity$;

    this.newActivity$ = this.sliderService.isActive.pipe(filter(isActive => isActive)).pipe(
      withLatestFrom(graphqlActivity),
      map(([_, activity]) => {
        return activity;
      })
    );

    this.showNav$ = this.newActivity$.pipe(distinctUntilChanged(), map(
      activity => (activity !== 'million' && activity !== '1vs1')
    ));


    this.sliderService.inReview.pipe(
      withLatestFrom(this.newActivity$),
      map(([inReview, activity]) => {
        // debugger;
        const inTest = ['test', 'finalTest'].indexOf(activity) > -1;
        this.showReview.next(inTest && !inReview);
        this.showExit.next(inReview || !inTest);
      })
    ).subscribe();

    if (!this.topic && !this.topics) { return; }

    this.config.allowTouchMove = (this.activity !== 'million');

    this.path = this.path || [];
    // debugger;
    const MATH_HIERARCHY = '03';
    let hierarchy;
    if (this.topic) {
      hierarchy = this.topic.hierarchy;
      this.path.push({ ...this.topic });
    } else if (this.topics) {
      hierarchy = this.topics[0];
      this.path.push({ name: 'מגוון נושאים', hierarchy });
    }
    this.type = (hierarchy.startsWith(MATH_HIERARCHY)) ? 'math' : 'text';
    if (this.path.length > 3) {
      this.path.shift();
    } else if (this.path.length < 3) {
      this.path.push({ name: '', hierarchy: '' });
    }
    this.uiStateService.setSubjectList(this.path);

    const source$ = this.getQuiz();
    this.loading$ = source$.pipe(pluck('loading'));
    this.error$ = source$.pipe(pluck('errors'));
    this.quiz$ = source$.pipe(pluck('data', 'problemsbyidsList'));

    /*this.querySubscription = this.quiz$.subscribe(_problems => {
      // debugger;
      this.problems = _problems;
      if (this.problems) {
        this.length = this.problems.length;
        this.currentProblemChanged(0);
      }
    });*/
    this.problems$ = this.quiz$.pipe(tap(_problems => {
      // debugger;
      this.problems = _problems;
      if (this.problems) {
        this.length = this.problems.length;
        this.currentProblemChanged(0);

        this.scoreSubscription = this.rightAnswers.pipe(bufferCount(_problems.length)).pipe(map((rightAnswers) => {
          const totalCount = rightAnswers.length;
          const correctCount = rightAnswers.filter(correct => correct).length;
          const score = Math.round(100 * correctCount / totalCount);

          this.uiStateService.setScore(score);

          // this.score.emit();
        })).subscribe();

      }
    }));
  }

  extractTopSubject(subject: { name: string; hierarchy: string; }): { name: string; hierarchy: string; } {
    const HIERARCHY_TO_NAME = {
      '01': 'לשון',
      '02': 'אזרחות',
      '03': 'מתמטיקה',
      '04': 'תנ"ך',
      '05': 'אנגלית',
      '06': 'היסטוריה',
      '07': 'מדעים'
    };
    const hierarchy = subject.hierarchy.substr(0, '01'.length);
    const name = (hierarchy in HIERARCHY_TO_NAME) ? HIERARCHY_TO_NAME[hierarchy] : 'לא נמצא';
    return { name, hierarchy };
  }

  getQuiz() {
    let hierarchies: string[];
    if (this.topic) {
      hierarchies = [this.topic.hierarchy];
    } else if (this.topics) {
      hierarchies = this.topics.map(t => typeof t === 'string' ? t : t.hierarchy);
    }

    const hierarchyToIds = (h: string): Observable<{ id: number }[]> => {
      return this.apiService.getSubjectProblems(h);
    };

    function shuffle<T>(a: T[]) {
      let j: number; let x: T; let i: number;
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
      }
      return a;
    }

    return zip(...hierarchies.map(h => hierarchyToIds(h)))
      .pipe(map((arraiesOfIds: { id: number }[][]) => {
        // Only shuffle for non-practice activities to keep practice order stable
        if (this.activity === 'practice') {
          return arraiesOfIds;
        }
        return arraiesOfIds.map(shuffle);
      }))
      .pipe(map((arraiesOfIds: { id: number }[][]) => {
        let howMany: number;
        switch (this.activity) {
          case 'test': howMany = 3; break;
          case 'finalTest': howMany = 5; break;
          case 'million': howMany = (14 + 1); break; // million + change question
          case '1vs1': howMany = 6; break;
          case 'practice': howMany = arraiesOfIds[0].length; break;
        }

        const fromEach = Math.min(1, howMany / arraiesOfIds.length);
        const result: { id: number }[] = [];
        for (const ids of arraiesOfIds) {
          result.push(...ids.slice(0, fromEach));
        }
        const left = howMany - result.length;
        result.push(...arraiesOfIds[0].slice(fromEach, fromEach + left));

        // Only shuffle for non-practice activities
        if (this.activity !== 'practice') {
          shuffle(result);
        }

        return result;
      })).pipe(flatMap(ids => {
        const cleanIds = ids.map(o => o.id);
        const inTest = ['test', 'finalTest'].indexOf(this.activity) > -1;
        return this.apiService.getProblemsByIds(cleanIds, inTest).pipe(
          map(problems => ({ data: { problemsbyidsList: problems } }))
        );
      })).pipe(shareReplay(1));
  }

  ngOnDestroy() {
    this.sliderService.unregister();
    if (this.scoreSubscription) { this.scoreSubscription.unsubscribe(); }
    return this.querySubscription && this.querySubscription.unsubscribe();
  }

  currentProblemChanged(index) {
    setTimeout(() => {
      this.uiStateService.setCurrentProblemId(this.problems[index].id);
    }, 0);
  }

  onReview(wasCorrect) {
    if (wasCorrect === undefined) {
      return;
    }
    this.rightAnswers.next(wasCorrect);
  }

  onAnswerChosen(answer: { id: number, correct: boolean }) {
    if (this.activity === 'million') {
      if (answer.correct) {
        of(0).pipe(delay(1500), map(() => {
          this.sliderService.nextSlide();
          this.millionService.advance();
        })).subscribe();
      } else {
        this.millionService.gameover();
      }
    }
    this.selected.emit(answer);
  }

  onFinish() {
    const inTest = ['test', 'finalTest'].indexOf(this.activity) > -1;

    if (inTest && !this.inReview) {
      this.inReview = true;
      this.sliderService.goToReview();
    } else {
      const topSubject$: Observable<{ name: string; hierarchy: string; }> = this.uiStateService.subjectList$.pipe(
        take(1),
        map(subjectList => {
          return this.extractTopSubject(subjectList[0]);
        })
      );

      topSubject$.pipe(take(1), map(subject => {
        this.router.stateService.go('activity', subject);
      })).subscribe();
    }
  }

  get finishText() {
    const ACTIVITY_TO_HEBREW = {
      practice: 'תרגול',
      test: 'בוחן',
      finalTest: 'מבחן'
    };
    const hebrew = (this.activity in ACTIVITY_TO_HEBREW) ?
      ACTIVITY_TO_HEBREW[this.activity] : 'פעילות';
    const end = this.inReview ? 'יציאה מה' : 'סיום ';
    return (end + hebrew);
  }
}

